export const organization = {
  entityFlag: [{
    value: '1', label: '是'
  }, {
    value: '0', label: '否'
  }],
  policyLevel: [{ // 政策级别
    value: 0, label: '默认政策'
  }, {
    value: 1, label: '一级政策'
  }, {
    value: 2, label: '二级政策'
  }, {
    value: 3, label: '三级政策'
  }, {
    value: 4, label: '四级政策'
  }, {
    value: 5, label: '五级政策'
  }, {
    value: 6, label: '六级政策'
  }, {
    value: 7, label: '七级政策'
  }, {
    value: 8, label: '八级政策'
  }, {
    value: 9, label: '九级政策'
  }, {
    value: 10, label: '十级政策'
  }, {
    value: 11, label: '十一级政策'
  }, {
    value: 12, label: '十二级政策'
  }, {
    value: 13, label: '十三级政策'
  }, {
    value: 14, label: '十四级政策'
  }, {
    value: 15, label: '十五级政策'
  }],
  InsBusinessSource: [{ // 机构类型
    value: 0, label: '总部内勤', desc: '适用于商户总部的内勤部门，可配置除“系统管理员”外角色的账号'
  }, {
    value: 1, label: '业务团队', desc: '适用于商户直属的小团队，可配置角色：团队长、业务员、出单内勤'
  }, {
    value: 8, label: '电销团队', desc: '适用于商户直属的电销部门，可配置角色：团队长、业务员、出单内勤'
  }, {
    value: 16, label: '分支机构', desc: '适用于商户直属的下游正式机构，可配置角色：机构负责人、业务员、出单内勤'
  }, {
    value: 64, label: '门店', hidden: true
  }, {
    value: 128, label: '合作渠道', desc: '适用于商户合作紧密的外部机构，可配置角色：团队长、业务员、渠道出单'
  }, {
    value: 256, label: '网销', hidden: true
  }, {
    value: 512, label: '出单团队', desc: '适用于商户直属的出单员部门，可配置角色：团队长、业务员、出单内勤'
  }, {
    value: 1024, label: '总部', hidden: true
  }],
  InsBusinessSourceNew: [{ // 机构类型
    value: 0, label: '总部内勤', hidden: true, desc: '适用于商户总部的内勤部门，可配置除“系统管理员”外角色的账号'
  }, {
    value: 1, label: '业务团队', desc: '适用于商户直属的小团队，可配置角色：团队长、业务员、出单内勤'
  }, {
    value: 8, label: '电销团队', desc: '适用于商户直属的电销部门，可配置角色：团队长、业务员、出单内勤'
  }, {
    value: 16, label: '分支机构', hidden: true, desc: '适用于商户直属的下游正式机构，可配置角色：机构负责人、业务员、出单内勤'
  }, {
    value: 64, label: '门店', hidden: true
  }, {
    value: 128, label: '合作渠道', desc: '适用于商户合作紧密的外部机构，可配置角色：团队长、业务员、渠道出单'
  }, {
    value: 256, label: '网销', hidden: true
  }, {
    value: 512, label: '出单团队', desc: '适用于商户直属的出单员部门，可配置角色：团队长、业务员、出单内勤'
  }, {
    value: 1024, label: '总部', hidden: true
  }],
  InsBusinessSourceNewFeiche: [{ // 机构类型
    value: 1, label: '业务团队', desc: '适用于商户直属的小团队，可配置角色：团队长、业务员、出单内勤'
  }, {
    value: 8, label: '电销团队', desc: '适用于商户直属的电销部门，可配置角色：团队长、业务员、出单内勤'
  }, {
    value: 16, label: '分支机构', desc: '适用于商户直属的下游正式机构，可配置角色：机构负责人、业务员、出单内勤'
  }, {
    value: 128, label: '合作渠道', desc: '适用于商户合作紧密的外部机构，可配置角色：团队长、业务员、渠道出单'
  }, {
    value: 512, label: '出单团队', desc: '适用于商户直属的出单员部门，可配置角色：团队长、业务员、出单内勤'
  }, {
    value: 1024, label: '总部'
  }],
  OrganizationLevel: [{ // 机构级别
    value: 0, label: '一级机构'
  }, {
    value: 1, label: '二级机构'
  }, {
    value: 2, label: '三级机构'
  }, {
    value: 3, label: '四级机构'
  }],
  OrganizationCategory: [{
    value: 1, label: '组织'
  }, {
    value: 2, label: '机构'
  }],
  OrgLevel: [{
    value: 'Q', label: '区'
  }, {
    value: 'Z', label: '部'
  }],
  lifeDateType: [{
    value: '1', label: '投保日期'
  }, {
    value: '2', label: '承保日期'
  }, {
    value: '3', label: '生效日期'
  }, {
    value: '4', label: '回执日期'
  }, {
    value: '5', label: '回访日期'
  }, {
    value: '6', label: '保单结算月'
  }, {
    value: '7', label: '结算日期'
  }],
  lifePolicyType: [{
    value: '1', label: '单个新增'
  }, {
    value: '2', label: '批量导入'
  }, {
    value: '3', label: '保司直连'
  }, {
    value: '4', label: '交互平台'
  }],
  // 保单状态
  orderStatusList: [
    {value: 1, label: '有效'},
    {value: 0, label: '已承保,待客户回执'},
    {value: 3, label: '退保'},
    {value: 4, label: '已承保,待回访'},
    {value: 5, label: '终止'},
    {value: 7, label: '犹豫期退保'},
    {value: 6, label: '中止'},
    {value: 9, label: '理赔终止'}
  ],
  organizationCurrentStatus: [{
    value: 0, label: '正常'
  }, {
    value: 8, label: '注销'
  }, {
    value: -1, label: '删除'
  }]

}

export default {
  organization
}



// WEBPACK FOOTER //
// ./src/data/organization.js